import template from "./integration-card-smartvault.html";

const integrationStatus = {
  INITIAL: "INITIAL",
  EMAIL_REQUEST: "EMAIL_REQUEST",
  NEEDS_AUTHORIZATION: "NEEDS_AUTHORIZATION",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
};

const IntegrationCardSmartvaultComponent = {
  template: template,
  controller: class IntegrationCardSmartvaultController {
    /* @ngInject */
    constructor($rootScope, $state, SmartVaultService) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.SmartVaultService = SmartVaultService;
    }

    $onInit() {
      this.loading = true;
      this.integrationStatus = integrationStatus.INITIAL;
      this.email = "";
      this.authorizationUri = null;
      this.error = null;
      this.authorizationHelpTries = 0;
      this.integrated();
    }

    requestEmail() {
      this.integrationStatus = integrationStatus.EMAIL_REQUEST;
    }

    validateEmail() {
      if (!this.emailForm.$valid) return;
      this.saveForm();
    }

    async integrated() {
      this.loading = true;
      const { integrated } = await this.SmartVaultService.integrated();
      this.integrationStatus = integrated
        ? integrationStatus.COMPLETED
        : integrationStatus.INITIAL;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async saveForm() {
      if (!this.email) return;
      try {
        const { authorizationUri } = await this.SmartVaultService.integrate(
          this.email
        );

        if (
          this.authorizationUri &&
          this.integrationStatus === integrationStatus.NEEDS_AUTHORIZATION
        ) {
          this.authorizationHelpTries++;
        }

        this.authorizationUri = authorizationUri ? authorizationUri : null;
        this.integrationStatus = authorizationUri
          ? integrationStatus.NEEDS_AUTHORIZATION
          : integrationStatus.COMPLETED;

        if (this.integrationStatus === integrationStatus.COMPLETED) {
          this.$state.go("createOrganizations");
        }
      } catch (e) {
        this.integrationStatus = integrationStatus.ERROR;
        this.error =
          e.data === "SmartVault email not found"
            ? "integrationCardSmartvault.error.emailNotFound"
            : "integrationCardSmartvault.error.generic";
      }

      this.$rootScope.$applyAsync();
    }

    retry() {
      this.email = "";
      this.integrationStatus = integrationStatus.EMAIL_REQUEST;
      this.authorizationUri = null;
      this.error = null;
    }
  },
};

export default IntegrationCardSmartvaultComponent;
